import Layout from "@/layout/Layout.vue";
import { P } from "@/config/permissions";

const comptaParametrageRoutes = {
    path: "/compta-parametrage",
    name: "compta-parametrage",
    component: Layout,
    redirect: "/compta-parametrage/liste",
    meta: {
        title: "Paramétrage comptable",
        icon: "mdi:book-open-variant",
        permissions: [P.PARAMETRAGE_COMPTABLE.BROWSE],
        noCache: true
    },
    children: [
        {
            path: "liste",
            name: "compta-parametrage-liste",
            meta: {
                title: "Paramétrage comptable",
                icon: "mdi:book-open-variant",
                noCache: true,
                permissions: [P.PARAMETRAGE_COMPTABLE.BROWSE]
            },
            component: () => import("@/views/comptaParametrage/ComptaParametrage.vue")
        }
    ]
};

export default comptaParametrageRoutes;
